import { Injectable } from '@angular/core';
import { SyskdServicePkg } from './syskdPkg.service';

@Injectable({
  providedIn: 'root',
})
export class SyskdService extends SyskdServicePkg {
  constructor() {
    super();
  }
}
